import ccValidator from "card-validator";

import TextFieldExtension from "../../@libs/TextFieldExtension";

import ccExpValidation from "../../validations/creditcard-exp";
import required from "@libs/required";

class CreditCardExpTextField extends TextFieldExtension {
	constructor(...args) {
		super(...args);
	}

	get val() {
		return super.val;
	}

	get id() {
		return super.id;
	}

	get name() {
		return super.name;
	}

	get isValid() {
		return super.isValid;
	}

	get rawValue() {
		const { month, year } = ccValidator.expirationDate(this.val);
		return {
			month,
			year,
		};
	}

	validate(val = required`val`, customValidation) {
		return super.validate(
			val,
			customValidation || super.validation || ccExpValidation
		);
	}

	displayError(val = required`val`) {
		super.displayError(val);
	}
}

export default CreditCardExpTextField;
